import { Vehicle, VehicleTransport } from '@/new-transport/_models/transport.model';

export const createVehicleTransport = (vehicle: Vehicle): VehicleTransport => ({
	id: vehicle.id,
	name: vehicle.name,
	capacity: vehicle.capacity,
	freeSeats: vehicle.capacity,
	crew: 0,
	visible: true,
	inUse: false,
	takenSeats: 0,
});
